import { createReducer, on } from '@ngrx/store';

import { RestAuditModel } from '@shared/interfaces/audit.interface';
import { RestDelinquencyModel } from '@shared/interfaces/delinquency.interface';

import {
  getDelinquencyChangesHistory,
  getDelinquencyChangesHistoryFailure,
  getDelinquencyChangesHistorySuccess,
  loadDelinquencyById,
  loadDelinquencyByIdFailed,
  loadDelinquencyByIdSucceded,
  loadDelinquencyList,
  loadDelinquencyListFailed,
  loadDelinquencyListSucceded,
} from './delinquency.actions';

export const delinquencyFeatureKey = 'delinquency';

export interface DelinquencyState {
  delinquenciesList: RestDelinquencyModel[];
  delinquenciesListLoading: boolean;

  delinquencyDetails?: RestDelinquencyModel;
  delinquencyDetailsLoading: boolean;

  auditModelList?: RestAuditModel[];
  auditModelListLoading?: boolean;
}

export const initialState: DelinquencyState = {
  delinquenciesList: [],
  delinquenciesListLoading: false,

  delinquencyDetailsLoading: false,
  auditModelList: [],
  auditModelListLoading: false,
};

export const reducer = createReducer(
  initialState,
  on(loadDelinquencyList, (state, action) => ({ ...state, delinquenciesListLoading: true })),
  on(loadDelinquencyListFailed, (state, action) => ({ ...state, delinquenciesListLoading: false })),
  on(loadDelinquencyListSucceded, (state, action) => ({
    ...state,
    delinquenciesListLoading: false,
    delinquenciesList: action.delinquencyList,
  })),

  on(loadDelinquencyById, (state, action) => ({ ...state, delinquencyDetailsLoading: true })),
  on(loadDelinquencyByIdFailed, (state, action) => ({ ...state, delinquencyDetailsLoading: false })),
  on(loadDelinquencyByIdSucceded, (state, action) => ({
    ...state,
    delinquencyDetailsLoading: false,
    delinquencyDetails: action.delinquencyDetails,
  })),

  /* get changes history */
  on(getDelinquencyChangesHistory, (state, action) => ({ ...state, auditModelListLoading: true })),
  on(getDelinquencyChangesHistorySuccess, (state, action) => ({
    ...state,
    auditModelList: action.auditModelList,
    auditModelListLoading: false,
  })),
  on(getDelinquencyChangesHistoryFailure, (state, action) => ({
    ...state,
    auditModelList: [],
    auditModelListLoading: false,
  }))
);
